module.exports = __webpack_public_path__ + "img/scorpius.cd0d73d7.png";